<template>
  <div   class="popUpMain">
    <div class="popUpMessageBody">
      <div class="popUpheader">
        <img @click="()=>$emit('close',true)" src="@/assets/path-2-copy.png" />
        <div class="headingText">{{ header.tagName}}</div>
      </div>
      <div class="popUpBody">
        <div>
          <span class="bodyContent">Tag Name :</span>
          <span class="bodyContent">Application Name :</span>
          <span class="bodyContent">Log Type :</span>
          <span class="bodyContent">Log Message :</span>
        </div>
        <div>
          <span class="bodyContentAns">{{header.tagName}}</span>
          <span class="bodyContentAns">{{ header.applicationName}}</span>
          <div>
            <span v-if="header.exceptionLog" class="bodyContentAns" >{{header.exceptionLog.logType }}</span>
            <span v-if="header.auditLog" class="bodyContentAns" >{{header.auditLog.logType }}</span>
          </div>
         <div class="logMessageContainer">
          <span v-if="header.exceptionLog" class="bodyContentAns"
            > {{ header.exceptionLog.logMessage }}</span
          >
          <span v-if="header.auditLog" class="bodyContentAns"
            > {{ header.auditLog.logMessage}}</span
          >
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props:{
      header:Object
    },
  data() {
    return {
    };
  },
  mounted(){
     console.log(this.header)
  },
  methods:{

  }
};
</script>
<style lang="scss" scoped>
.popUpMain {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(151, 163, 163, 0.615);
  z-index: 4;
}
.popUpMessageBody {
  width: 600px;
  min-height: 300px;
  max-height: 600px;
  background-color: white;
  overflow: hidden;
}
.headingText {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.popUpheader {
  height: 64px;
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;

  }
}
.popUpBody {
    display: flex;
    gap:60px;
}
.bodyContent {
   display: block;
   padding: 20px;
}
.bodyContentAns {
    display: block;
    padding: 20px;
    font-weight: bold;
    
}
.logMessageContainer{
  height: 380px;
  width: 380px;
  text-align: justify;
  text-justify: inter-word;
  overflow-y: scroll;
  span{
    text-align: justify;
  text-justify: inter-word;
  }

}
</style>
